<template>
<div class="header-wrapper">

    <header>
        <div class="header-body">
            <div class="header-logo">
                <a :href="setURL"><img src="../assets/ns_word_mark_dark.svg" alt="Nu Skin" /></a>
            </div>
        </div>

    </header>
    <div class="hero-section">
        <div class="hero-wrapper">

      <div class="india-page-title">
        <h1>
          {{strings.page_title}}
          <small>{{strings.page_subtitle}}</small>
        </h1>
      </div>
        </div>
    </div>
</div>
</template>

<script>
export default {
    name: 'Header',
    props: {
        strings: Object
    },
    data() {
        return {

        };
    },


    computed: {
        setURL() {
            if (process.env.NODE_ENV === 'production') {
                return 'https://www.nuskin.com/content/region-selector.html#region-selection';
            } else {
                return 'https://test.nuskin.com/content/region-selector.html#region-selection';
            }
        }
    }
};
</script>

<style lang="scss" scoped>
@use 'sass:map';
@use '~@nuskin/ns-core-styles/src/scss/colors';
@use '~@nuskin/ns-core-styles/src/scss/buttons';
@import '@nuskin/ns-core-styles/src/scss/_global.mixins.scss';

.header-logo {
  /* Ensure logo is always on top */
  align-self: flex-start;
    img {
        max-width: 150px;
        width: 100%;
        min-width: 150px;
    }
}

header {
      box-shadow: 0 2px 4px 0 rgba(0, 0, 0, .15);
        display: flex;
        background: #fff;
        padding: 8px 15px;
        .header-body {
            display: flex;
            justify-content: space-between;
            width: 100%;
            max-width: 1440px;
            margin: 0 auto;
        }
}

 .hero-section {
    background-color: #f1f1f1;
    padding: 20px;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    text-align: left;
    margin: 30px auto 0;
    max-width: 1440px;
    .hero-wrapper {
    max-width: 1440px;
    display: flex;
}
    .india-page-title {
      max-width: 1440px;

      font-family: "inter", sans-serif;

      h1 {
        font-family: "Lora", sans-serif !important;
        font-size: 42px !important;
        font-style: normal !important;
        font-weight: 400 !important;
        line-height: 48px !important;
        margin: 0 !important;
        text-transform: capitalize !important;

        small {
          font-family: "Lora", sans-serif;
          font-size: 22px;
          font-style: normal;
          font-weight: 700;
          line-height: 28px;
          display: block;
          text-transform: none !important;
          margin-top: 15px;
        }
      }
    }
  }

</style>

